import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const bloquesPedagogicosApi = `${baseUrl}/bloques-pedagogicos`;

export const allBloquesPedagogicosService = async (params) => {
  const res = await axios.get(bloquesPedagogicosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveBloquesPedagogicosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${bloquesPedagogicosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(bloquesPedagogicosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneBloquesPedagogicosService = async (id) => {
  const res = await axios.get(`${bloquesPedagogicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteBloquesPedagogicosService = async (id) => {
  const res = await axios.delete(`${bloquesPedagogicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
